module.exports = __webpack_public_path__ + "img/blackdot.7919768a.png";